// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ContactModal_contentWrapper__NbV_X","title":"ContactModal_title__duy_0","text":"ContactModal_text__bEjke","submitButton":"ContactModal_submitButton__3flO5"};